var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBahrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 24.4519C19.227 24.4519 24.5996 19.0793 24.5996 12.4519C24.5996 5.82449 19.227 0.451904 12.5996 0.451904C5.97219 0.451904 0.599609 5.82449 0.599609 12.4519C0.599609 19.0793 5.97219 24.4519 12.5996 24.4519Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5993 0.451904C10.191 0.451904 7.94889 1.16183 6.06958 2.38306L9.15578 4.45161L5.29492 6.45158L9.15578 8.45154L5.29492 10.4515L9.15578 12.4512L5.29492 14.4512L9.15578 16.4511L5.29492 18.4512L9.15578 20.4512L6.0692 22.5204C7.94861 23.7419 10.1909 24.4519 12.5993 24.4519C19.2266 24.4519 24.5993 19.0793 24.5993 12.4519C24.5993 5.82453 19.2266 0.451904 12.5993 0.451904V0.451904Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahrain);
export default __webpack_public_path__ + "static/media/Bahrain.82e3c1d7a73dc10240041f7596545649.svg";
export { ForwardRef as ReactComponent };